export default "__VITE_ASSET__BnS4CDJh__"